<div class="container bg2 page-sub footer-none">

  <section class="header fixed">

    <article class="header-page">

      <a class="close-btn" backButton></a>

      <div class="page-name-box">설정</div>

    </article>

  </section>

  <section class="setting-page">
    <div class="inner wrap">

      <div class="setting-list">

        <app-option-item *ngFor="let option of optionItems"
                         [optionItem]="option"></app-option-item>

        <!-- div class="setting-box">
          <div class="setting-tit-box">푸시 알람 수신여부</div>
          <div class="setting-des-box">
            새로운 영상이나 정보가 나왔을 때 알립니다.
          </div>
          <div class="setting-option-box">
            <label>
              <input type="radio" name="s5" checked><span class="txt">켜기</span>
            </label>
            <label>
              <input type="radio" name="s5"><span class="txt">끄기</span>
            </label>
          </div>
        </div -->

        <!-- div class="setting-box">
          <div class="setting-tit-box">계정 연동 해지</div>
          <div class="setting-des-box">
            연동된 sns계정을 해지합니다.
          </div>
          <div class="setting-btn-box">
            <a href="#none" class="setting-btn">연동해지</a>
          </div>
        </div -->

        <div class="setting-box">
          <div class="setting-tit-box">책갈피 연동</div>
          <div class="setting-des-box">
            책갈피를 연동 하면, 다른 기기와 다른 브라우저에서도 동일한 책갈피를 볼 수 있습니다.
          </div>
          <div class="setting-btn-box">
            <div *ngIf="this.snsInfo" class="bookmark-box">
              <div class="naver-logo {{ this.snsInfo?.naver ? 'disconnect' : '' }}" (click)="onBookmarkSync($event)"></div>
            </div>
          </div>
        </div>


        <div class="setting-box">
          <!-- div class="setting-tit-box">듣고 배우는 한국어</div>
          <div class="setting-des-box">
            버전: {{ APP_VERSION }}
          </div -->
          <div class="setting-btn-box">
            <a class="setting-btn" [routerLink]="['/open-source']">오픈 소스 라이선스 고지</a>
          </div>
        </div>

      </div>

    </div>

  </section>

</div>

<!-- 공용 팝업 -->
<app-common-popups></app-common-popups>
